import { ProductVariant } from '@/queries/types/graphql';

const getProductVariantSize = (
  variant: ProductVariant | undefined,
): string | undefined => {
  return variant?.selectedOptions.find((opt) => opt?.name === 'Size')?.value;
};

export default getProductVariantSize;
